import { CCEntityType } from "components/CC/types/entityConfig";
import { ConnectionCreatorScenarioCategory } from "types/enums";

/**
 * Map from CCEntityType to ConnectionCreatorScenarioCategory
 */
export const CC_ENTITY_TO_SCENARIO_CATEGORY: Record<CCEntityType, ConnectionCreatorScenarioCategory> = {
    [CCEntityType.StructureValidate]: ConnectionCreatorScenarioCategory.StructureValidate,
    [CCEntityType.StructureModify]: ConnectionCreatorScenarioCategory.StructureModify,
    [CCEntityType.StructureAutocomplete]: ConnectionCreatorScenarioCategory.StructureAutocomplete,
    [CCEntityType.Integration]: ConnectionCreatorScenarioCategory.Integration,
    [CCEntityType.TrackingIn]: ConnectionCreatorScenarioCategory.IncomingPostback,
    [CCEntityType.TrackingOut]: ConnectionCreatorScenarioCategory.OutgoingPostback,
};
